'use client';

import type { ComponentProps } from 'react';

import TextLink from '@dvd/components/TextLink';
import { useMacDownloadHref } from '@hooks/useMacDownloadHref';

type MacDownloadTextLinkProps = ComponentProps<typeof TextLink>;

/**
 * TextLink to the Mac download, routed per device by `useMacDownloadHref`.
 */
const MacDownloadTextLink = ({ cta, ...props }: MacDownloadTextLinkProps) => {
  const href = useMacDownloadHref();
  return <TextLink {...props} cta={{ ...cta, href }} />;
};

export default MacDownloadTextLink;
